import { GroupType } from '../../model/enumerations';
import template from './mx-search-state.component.html';

angular.module('mx.SolutionBuilderAgent').component('mxSearchState', {
	bindings: {
		uiToken: '@',
		preprocessors: '<',
	},
	controller: MxSearchStateCtrl,
	controllerAs: 'vm',
	template: template,
});

MxSearchStateCtrl.$inject = [
	'mx.shell.EventService',
	'$scope',
	'$timeout',
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.SearchQueryService',
	'mx.shell.RoutingService',
	'$location',
	'mx.internationalization',
];

function MxSearchStateCtrl(eventService, $scope, $timeout, searchService, searchQueryService, routingService, $location, i18n) {
	const vm = this;
	vm.i18n = i18n.get('solutionBuilderAgent.components.mx-search-state');

	const quickFilterCondition = {
		active: false,
		type: 'quick-filter',
		tooltip: '',
		title: i18n.get('solutionBuilderAgent.components.mx-search-query-builder.quickFilter') + ':',
		onReset: function () {
			vm.preprocessors.quickFilterPreprocessor.resetFilters();
		},
	};

	const keywordCondition = {
		tooltip: '',
		type: 'keyword-filter',
		title: i18n.get('solutionBuilderAgent.components.mx-advanced-search.keyword') + ':',
		onReset: function () {
			searchService.resetKeywordSearch(vm.uiToken);
		},
	};

	const gridCondition = {
		tooltip: '',
		title: i18n.get('solutionBuilderAgent.components.mx-search-state.grid') + ':',
		onReset: function () {
			searchService.resetGridSearch(vm.uiToken);
		},
	};

	const advancedCondition = {
		tooltip: '',
		title: i18n.get('solutionBuilderAgent.components.mx-advanced-search.advancedSearch') + ':',
		shortValue: i18n.get('solutionBuilderAgent.components.mx-search-state.complexCondition'),
		onReset: function () {
			searchService.resetAdvancedSearch();
		},
	};

	const customFormCondition = {
		tooltip: '',
		title: i18n.get('solutionBuilderAgent.components.common.configurationForm') + ':',
		onReset: function () {
			searchService.resetCustomFormSearch(vm.uiToken);
		},
	};

	vm.conditions = [quickFilterCondition, keywordCondition, gridCondition, advancedCondition, customFormCondition];

	vm.onReset = onReset;
	vm.searchForm = null;

	vm.$onInit = function () {
		init();
	};

	eventService.subscribeTo(mx.shell.EventCodes.Search, init, $scope);
	const andTitle = ' ' + i18n.get('solutionBuilderAgent.components.mx-search-query-condition.operatorAND') + ' ';

	$scope.$watch('vm.preprocessors.quickFilterPreprocessor.color', (newVal) => {
		if (newVal) {
			const quickFilters = vm.preprocessors.quickFilterPreprocessor.getFilters();
			quickFilterCondition.active = true;
			quickFilterCondition.tooltip = '';
			Object.keys(quickFilters).forEach((filter) => {
				if (quickFilters[filter].active) {
					quickFilterCondition.tooltip += (quickFilterCondition.tooltip ? andTitle : '') + '"' + quickFilters[filter].title + '"';
				}
				quickFilterCondition[filter] = quickFilters[filter].active;
			});
		} else {
			quickFilterCondition.active = false;
		}

		vm.isVisible = isVisible();
	});

	return vm;

	function isVisible() {
		const wasVisible = vm.isVisible;
		const isVisible = vm.conditions.some((condition) => condition.active);
		if (wasVisible !== isVisible) {
			$timeout(() => {
				eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged, 'mxSearchStateVisibility', isVisible);
			});
		}
		return isVisible;
	}

	function init() {
		const gLevel = 0;
		const params = searchService.currentSearch();
		const context = searchService.currentContext();

		if (params && params.context === context) {
			keywordCondition.active = gridCondition.active = advancedCondition.active = customFormCondition.active = false;

			if (params.keyword) {
				keywordCondition.active = true;
				keywordCondition.tooltip = i18n.getFormatted('solutionBuilderAgent.components.mx-search-state.keywordIs', params.keyword);
				keywordCondition.shortValue = params.keyword;
			}

			const removeHtmlTags = (text) => text.replace(/<(?:.|\n)*?>/gm, '');

			const gridConditions = params.searchForm.getGroup(GroupType.GridSearch)?.conditions;
			if (Array.isArray(gridConditions) && gridConditions.length) {
				gridCondition.active = true;
				gridCondition.tooltip = removeHtmlTags(getStringConditions(params.searchForm, gridConditions));
				gridCondition.shortValue =
					gridConditions.length === 1
						? '"' + ((gridConditions[0].__property || {}).Title || gridConditions[0].property) + '"'
						: i18n.getFormatted('solutionBuilderAgent.components.mx-search-state.numColumns', gridConditions.length);
			}

			const queryBuilderGroup = params.searchForm.getGroup(GroupType.QueryBuilder);
			const advancedConditions = queryBuilderGroup?.conditions;
			if (Array.isArray(advancedConditions) && advancedConditions.length) {
				let advancedConditionsString = getStringGroup(queryBuilderGroup, gLevel);
				if (advancedConditionsString.indexOf('AND ') === 0) {
					advancedConditionsString = advancedConditionsString.substring(4);
				}
				advancedConditionsString = removeHtmlTags(advancedConditionsString);
				advancedCondition.active = true;
				advancedCondition.tooltip = advancedConditionsString;
			}

			const formConditions = params.searchForm.customFormConditions;
			if (Array.isArray(formConditions) && formConditions.length) {
				let formConditionsString = '';
				formConditions.forEach((cond) => {
					if (Boolean(cond.title) && Boolean(cond.value)) {
						formConditionsString += `${formConditionsString.length ? ' AND ' : ''}${cond.title} "${cond.value}"`;
					}
				});

				customFormCondition.active = true;
				customFormCondition.tooltip = formConditionsString;
				customFormCondition.shortValue =
					formConditions.length === 1
						? `${formConditions[0].title} "${formConditions[0].value}"`
						: i18n.getFormatted('solutionBuilderAgent.components.mx-search-state.numFields', formConditions.length);
			}
			vm.isVisible = isVisible();
		}
	}

	function onReset() {
		searchService.resetSearch(vm.uiToken);
		if (vm.preprocessors.quickFilterPreprocessor) {
			vm.preprocessors.quickFilterPreprocessor.resetFilters();
		}
	}

	function getStringConditions(root, conditions) {
		let cLevel = 0;
		let query = '';

		conditions.forEach(function (condition) {
			const operatorTitle = cLevel > 0 ? i18n.get('solutionBuilderAgent.components.mx-search-query-condition.operator' + root.logicalOperatorTitle) + ' ' : '';

			const conditionTitle = condition.type === 'Expression' ? 'Expression' : condition.__property.Title || condition.__property.Name;
			const value = searchQueryService.getConditionString(condition);

			if (value) {
				query += operatorTitle + conditionTitle + ' ' + searchQueryService.getConditionString(condition);
			}
			cLevel++;
		});
		return query;
	}

	function getStringGroup(group, groupLevel) {
		let query = groupLevel > 0 ? i18n.get('solutionBuilderAgent.components.mx-search-query-group.operator' + group.logicalOperatorTitle) + ' ' : '';
		if (group.conditions) {
			query += getStringConditions(group, group.conditions);
		}
		if (group.groups) {
			let level = 1;

			group.groups.forEach((itGroup) => {
				query += getStringGroup(itGroup, level);
				level++;
			});
		}
		return query;
	}
}
